export const MASONRY_ITEM_WIDTH = 220;

export const isBigItem = (index: number): boolean => index === 2 || !((index - 2) % 5);
